import { render, staticRenderFns } from "./HeaderNormal.vue?vue&type=template&id=70764150&scoped=true"
import script from "./HeaderNormal.vue?vue&type=script&lang=js"
export * from "./HeaderNormal.vue?vue&type=script&lang=js"
import style0 from "./HeaderNormal.vue?vue&type=style&index=0&id=70764150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70764150",
  null
  
)

export default component.exports